import { _ } from "../../../polyglot/polyglot.js";
import AbstractFormStep from "../../AbstractFormStep.js";

/**
 * The step to choose various import options for Tripletex.
 */
export default class ImportOptionsSelectionStep extends AbstractFormStep {
	_populateForm(form) {
		const items = this._context.fiscalYears.map((item) => ({
			label: item.year,
			value: item,
		}));

		this._dropdown = form.newDropDownField({
			items,
			label: _("Fiscal year"),
			attribute: "fiscalYear",
			name: "select-fiscal-year",
			dataTestName: "select-item",
			liveSearch: true,
		});

		this._switchItem = form.switchButton({
			attribute: "includeInvoices",
			label: _("Include accounts payable and receivable"),
		});
	}

	_shouldSubmitOnStart() {
		return false;
	}
}
